import React from 'react'
import Icon from 'components/Icon'

const BoxButton = ({ selected, icon, children, ...props }) => (
  <div
    className={`
      relative
      inline-block
      cursor-pointer
      w-40
      h-40
      border
      transition
      duration-200
      ease-in-out
      overflow-hidden
      antialiased
      ${ selected ?
          'border-primary bg-primary text-white' :
          'border-gray-400 bg-gray-100 text-gray-800 hover:bg-gray-200'
      }
    `}
    {...props}
  >
    <Icon icon={icon} className="absolute top-0 left-0 mt-3 ml-3 text-3xl" />

    <div className="absolute bottom-0 mb-3 ml-3">
      { children }
    </div>
  </div>
)

export default BoxButton
